import axioApi, { setHeader } from 'api/root.api';

export const loginInfoNum = async (token)=>{
    const urlEnd = '/editor/statistics/v1/project/calculate';
    setHeader('Authorization', `Bearer ${token}`);
    const response = await axioApi.get(urlEnd);
    const result = response.data;
    return result;
};